import { IoMdNotifications } from 'react-icons/io';
import { MdPlayArrow } from 'react-icons/md';
import { Button } from 'rsuite';
import styles from './PageHeader.module.scss';

type PageHeaderProps = {
  lastUpdate?: string;
  onHelpClick?: () => void;
  onViewPlanClick?: () => void;
};

export const PageHeader = ({ lastUpdate, onHelpClick, onViewPlanClick }: PageHeaderProps) => {
  const formattedDate = lastUpdate || new Date().toLocaleDateString('pt-BR');

  return (
    <div className={styles.container}>
      <div className={styles.leftContent}>
        <div className={styles.iconWrapper}>
          <IoMdNotifications size={20} className={styles.icon} />
        </div>
        <div className={styles.textContent}>
          <div className={styles.titleRow}>
            <h1 className={styles.title}>Central de Monitoramento</h1>
            <span className={styles.lastUpdate}>Última atualização: {formattedDate}</span>
          </div>
          <p className={styles.subtitle}>
            Configure alertas para ser notificado sobre mudanças importantes.
            {/* "Veja seu plano" oculto por enquanto — não entra nesta primeira entrega.
            {' '}
            <Button appearance="link" className={styles.viewPlanLink} onClick={onViewPlanClick}>
              Veja seu plano
            </Button> */}
          </p>
        </div>
      </div>
      {/* Veja como usar oculto por enquanto — implementar futuramente
      <button type="button" className={styles.helpButton} onClick={onHelpClick}>
        <div className={styles.helpIconWrapper}>
          <MdPlayArrow size={18} className={styles.helpIcon} />
        </div>
        <span className={styles.helpText}>Veja como usar</span>
      </button> */}
    </div>
  );
};
